// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as LegacyIcon from "../images-and-icons/LegacyIcon.res.js";
import * as ReactAria from "react-aria";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
let styles = {
  view: {
    "borderRadius-kaIpWk": "borderRadius-x1f96onm",
    "alignItems-kGNEyG": "alignItems-x6s0dn4",
    "display-k1xSpc": "display-x78zum5",
    "justifyContent-kjj79g": "justifyContent-xl56j7k",
    $$css: "wino-gc:src/resources/actions/IconButton.res.js:15"
  },
  xxsmallView: {
    "height-kZKoxP": "height-xd7y6wv",
    "width-kzqmXN": "width-xw4jnvo",
    $$css: "wino-gc:src/resources/actions/IconButton.res.js:21"
  },
  xsmallView: {
    "height-kZKoxP": "height-xd7y6wv",
    "width-kzqmXN": "width-x23j0i4",
    $$css: "wino-gc:src/resources/actions/IconButton.res.js:25"
  },
  smallView: {
    "height-kZKoxP": "height-x1s1d1n7",
    "width-kzqmXN": "width-x1n7h9c3",
    $$css: "wino-gc:src/resources/actions/IconButton.res.js:29"
  },
  normalView: {
    "height-kZKoxP": "height-x1vqgdyp",
    "width-kzqmXN": "width-x100vrsf",
    $$css: "wino-gc:src/resources/actions/IconButton.res.js:33"
  }
};
function viewStyleFromParams(size, borderedColor, hoveredColor) {
  let tmp;
  let exit = 0;
  if (size !== undefined) {
    if (size === "xxsmall") {
      tmp = styles.xxsmallView;
    } else if (size === "xsmall") {
      tmp = styles.xsmallView;
    } else if (size === "small") {
      tmp = styles.smallView;
    } else if (size === "normal") {
      tmp = styles.normalView;
    } else {
      exit = 1;
    }
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = {};
  }
  return [tmp, borderedColor !== undefined ? {
    borderColor: borderedColor,
    borderRadius: "5px",
    borderStyle: "solid",
    borderWidth: "1px"
  } : {}, hoveredColor !== undefined ? {
    borderColor: hoveredColor
  } : {
    borderColor: "#d7d7e0"
  }];
}
let make = React.forwardRef((props, ref) => {
  let __disabled = props.disabled;
  let __bold = props.bold;
  let borderedColor = props.borderedColor;
  let hoveredColor = props.hoveredColor;
  let __color = props.color;
  let name = props.name;
  let color = __color !== undefined ? __color : "#797885";
  let bold = __bold !== undefined ? __bold : false;
  let disabled = __disabled !== undefined ? __disabled : false;
  let match = Hover.use(ref == null ? undefined : Primitive_option.some(ref), undefined, undefined);
  let hovered = match[1];
  let fill = hovered && hoveredColor !== undefined && !disabled && Stdlib_Option.isNone(borderedColor) ? hoveredColor : color;
  let hoveredColor$1 = hovered ? hoveredColor : undefined;
  let ariaProps = ReactAria.mergeProps({
    "aria-label": name
  }, props.ariaProps);
  let newrecord = {
    ...Stylex.props(...Belt_Array.concatMany([[styles.view], viewStyleFromParams(props.marginSize, borderedColor, hoveredColor$1)]))
  };
  return JsxRuntime.jsx(Touchable.make, {
    children: JsxRuntime.jsx("div", (newrecord.children = JsxRuntime.jsx(LegacyIcon.make, {
      name: name,
      fill: fill,
      size: props.size,
      stroke: bold ? fill : undefined
    }), newrecord)),
    ariaProps: ariaProps,
    disabled: disabled,
    excludeFromTabOrder: true,
    onPress: props.onPress,
    ref: match[0]
  });
});
let make$1 = React.memo(make);
export { make$1 as make };
/* styles Not a pure module */